export const CHECKOUT_URL = 'https://perio-en.impultienda.ar/checkout/';

export const ctaSubline = 'Instant access · One-time payment of $27 USD · 7-day guarantee';

export const images = {
  mockup: 'https://cdn.magicpatterns.com/uploads/a2bwzb4gkBzEeJBGxy3m6D/PERIO-EN.png',
  creator: 'https://cdn.magicpatterns.com/uploads/3zdUX8XAod2AX3GYQgwpL6/DR._NATHAN_BROOKS_-_ORTHO.png',
};

export const packageItems = [
  {
    title: 'Perio Blueprint™ — 6 Premium Volumes',
    description:
      'The complete visual framework for organizing periodontal knowledge, assessment information, classification concepts, risk considerations, and case documentation.',
    value: '$97',
  },
  {
    title: 'Bonus #1 — Perio Case Decoder™: 20 Educational Practice Cases',
    description: 'Practice organizing your reasoning through fictional periodontal scenarios.',
    value: '$47',
  },
  {
    title: 'Bonus #2 — The 15-Minute Perio Case Review Protocol™',
    description: 'A condensed worksheet for structuring your initial case review.',
    value: '$37',
  },
  {
    title: 'Bonus #3 — The Perio Error & Knowledge Gap Library™',
    description: 'Educational examples designed to help you identify concepts and questions that deserve further review.',
    value: '$39',
  },
  {
    title: 'Bonus #4 — 30 ChatGPT Prompts for Periodontal Study™',
    description: 'A curated collection of prompts for organizing notes, creating exercises, and reviewing concepts.',
    value: '$29',
  },
  {
    title: 'Bonus #5 — The 30-Point Perio Study & Case Review Checklist™',
    description: 'A practical checklist for organizing your study sessions and educational case reviews.',
    value: '$19',
  },
];

export const finalRecap = [
  '6 Premium Educational Volumes',
  'The Periodontal Master Map',
  'Periodontal Assessment Maps',
  'Classification Study Maps',
  'Educational Clinical Pathways',
  'Case Analysis Worksheets',
  '20 Educational Practice Cases',
  'The 15-Minute Perio Case Review Protocol',
  '5 Professional Bonuses',
  'Instant Digital Access',
  'A 7-Day Guarantee',
];
